import type { MessageDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

export const resendVerificationEmail = async () => {
  const response = await axios.post<MessageDto, AxiosResponse<MessageDto>>(
    "/auth/verify-email/resend",
  );

  return response.data;
};

export const verificationEmaiByAdmin = async (email: string) => {
  const response = await axios.post<MessageDto, AxiosResponse<MessageDto>>(
    "/auth/verify-email/admin",
    null,
    {
      params: {
        email: email,
      },
    },
  );
  return response.data;
};

export const useResendVerificationEmail = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: resendVerificationEmailFn,
  } = useMutation({
    mutationFn: resendVerificationEmail,
  });

  return { resendVerificationEmail: resendVerificationEmailFn, loading, error };
};

export const useSendVerificationEmailByAdmin = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: verificationEmaiByAdminFn,
  } = useMutation({
    mutationFn: (email: string) => verificationEmaiByAdmin(email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["filter-user"] });
    },
  });

  return { verificationEmaiByAdmin: verificationEmaiByAdminFn, loading, error };
};
